import React, { Component } from 'react';
import Vas from '../Vas';
//import '../css/CustomerCreateContract.css';
import { LinkButton } from 'component-lib';

class ContractCancelSuccess extends Component
{

  constructor(props)
  {
    super(props);
    this.state = {};
    this.ContractId = props.match.params.ContractId;
    this.CustomerId = props.match.params.CustomerId;
    this.CustomerName = props.match.params.CustomerName;
  }
 
  Cancel(){
    if(this.CustomerName !== undefined){
      Vas.GetView("Contract",{Id: this.ContractId,CustomerId:this.CustomerId, CustomerName:this.CustomerName}, true);

    } else {
      /*if(localStorage.getItem('vas_role') !== '1'){
        Vas.GetView("Contracts",{All:true},true);
      }else{
        Vas.GetView("Contracts",{All:false},true);
      }*/
    }
    
  }
  render()
  {
    
    return (
      <div className={"PaymentContainer"}>
      <div className={"form"}>
        <table >
          <thead>
            <tr>
              <th style={{fontSize:'large',width:'400px'}} colSpan={2}>
                {Vas.Resources.Labels["CancelationSuccess"]}
                <br />
                <br />
              </th>
            </tr>
          </thead>
        <tbody>
          <tr></tr>
          <tr>
            <td style={{ width:'92px', fontSize:'14px' }}>
              {Vas.Resources.Labels["LinkLoginFemininum"]}
            </td>
            <td>
              <div style={{ textAlign: 'left'}}>
                <LinkButton 
                  Text={Vas.Resources.Labels["ContractOverView"]} 
                  Id={"LinkLogin"} 
                  OnClick={()=>{this.Cancel();}} />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
      </div>
    );
  }
}
export default ContractCancelSuccess;
